import { useEffect } from 'react';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import {
  ShapeSelect,
  ImageList,
  ProductSearch as FormProductSearch,
} from '../../widgets';
import { ReviewPayload } from '../../schema';
import { CommentStatus, Image, SearchProduct } from '../../types';
import _ from 'lodash';
import { Updater, useImmer } from 'use-immer';

const FormReview = ({
  imageProps,
  disabledFields,
}: {
  imageProps: {
    list: Image[];
    action: Updater<Image[]>;
  };
  disabledFields?: { [key: string]: string };
}): JSX.Element => {
  const {
    register,
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useFormContext<ReviewPayload>();
  const handleShapeSelect = (value: number) => {
    setValue('amount', value);
    trigger('amount');
  };

  const [productSearch, setProductSearch] = useImmer<{
    show: boolean;
    item: SearchProduct;
  }>({
    show: false,
    item: {
      title: '',
      product_id: '',
      handle: '',
    },
  });
  useEffect(() => {
    if (productSearch.item.product_id.length > 0) {
      setValue('target_id', productSearch.item.product_id);
      trigger('target_id');
    }
  }, [productSearch.item.product_id]);
  return (
    <>
      <div className="space-y-4 mt-4">
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Tên người đánh giá
            <span className="text-red-600 ml-1">*</span>
          </label>
          <input
            type="text"
            {...register('name')}
            className={clsx(
              errors.name
                ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
              'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
            )}
          />
          {errors.name ? (
            <p className="text-xs text-red-600">{errors.name.message}</p>
          ) : null}
        </div>
        <div className="flex space-x-4">
          <div className="space-y-1 flex flex-col flex-1">
            <label className="block text-sm font-medium text-gray-700">
              Email
              <span className="text-red-600 ml-1">*</span>
            </label>
            <input
              type="text"
              {...register('email')}
              className={clsx(
                errors.email
                  ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                  : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
                'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
              )}
            />
            {errors.email ? (
              <p className="text-xs text-red-600">{errors.email.message}</p>
            ) : null}
          </div>
          <div className="space-y-1 flex flex-col flex-1">
            <label className="block text-sm font-medium text-gray-700">
              Số điện thoại
            </label>
            <input
              type="text"
              {...register('phone')}
              className={clsx(
                errors.phone
                  ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                  : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
                'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
              )}
            />
            {errors.phone ? (
              <p className="text-xs text-red-600">{errors.phone.message}</p>
            ) : null}
          </div>
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Chọn sản phẩm
            <span className="text-red-600 ml-1">*</span>
          </label>
          <input
            type="text"
            className={clsx(
              errors.target_id
                ? 'border-red-300 text-red-600 placeholder-red-500 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
              !_.isUndefined(disabledFields) &&
                !_.isUndefined(disabledFields['target_id'])
                ? 'pointer-events-none bg-gray-100'
                : null,
              'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm cursor-pointer',
            )}
            placeholder="Click để chọn sản phẩm"
            readOnly
            value={
              !_.isUndefined(disabledFields) &&
              !_.isUndefined(disabledFields['target_id'])
                ? _.toString(disabledFields['target_id'])
                : productSearch.item.title
            }
            onClick={event => {
              event.preventDefault();
              setProductSearch(draft => {
                draft.show = true;
              });
            }}
          />
          {errors.target_id ? (
            <p className="text-xs text-red-600">{errors.target_id.message}</p>
          ) : null}
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Đánh giá
            <span className="text-red-600 ml-1">*</span>
          </label>
          <div className="block">
            <ShapeSelect value={watch('amount')} action={handleShapeSelect} />
          </div>
          {errors.amount ? (
            <p className="text-xs text-red-600">{errors.amount.message}</p>
          ) : null}
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Tiêu đề
          </label>
          <input
            type="text"
            {...register('title', {
              setValueAs(value) {
                return _.isString(value) && value.length > 0 ? value : null;
              },
            })}
            className={clsx(
              errors.title
                ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
              'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
            )}
          />
          {errors.title ? (
            <p className="text-xs text-red-600">{errors.title.message}</p>
          ) : null}
          <div className="space-x-2 pt-1 hidden lg:flex">
            <button
              type="button"
              onClick={() => {
                setValue('title', 'Khá tệ');
              }}
              className="inline-flex text-xs px-3 py-1 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 justify-center"
            >
              Khá tệ
            </button>
            <button
              type="button"
              onClick={() => {
                setValue('title', 'Bình thường');
                trigger('title');
              }}
              className="inline-flex text-xs px-3 py-1 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 justify-center"
            >
              Bình thường
            </button>
            <button
              type="button"
              onClick={() => {
                setValue('title', 'Sản phẩm tốt');
                trigger('title');
              }}
              className="inline-flex text-xs px-3 py-1 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 justify-center"
            >
              Sản phẩm tốt
            </button>
            <button
              type="button"
              onClick={() => {
                setValue('title', 'Giá tốt');
                trigger('title');
              }}
              className="inline-flex text-xs px-3 py-1 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 justify-center"
            >
              Giá tốt
            </button>
            <button
              type="button"
              onClick={() => {
                setValue('title', 'Tuyệt vời');
                trigger('title');
              }}
              className="inline-flex text-xs px-3 py-1 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 justify-center"
            >
              Tuyệt vời
            </button>
          </div>
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Mô tả
            <span className="text-red-600 ml-1">*</span>
          </label>
          <textarea
            {...register('desc')}
            className={clsx(
              errors.desc
                ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
              'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
            )}
            rows={3}
          ></textarea>
          {errors.desc ? (
            <p className="text-xs text-red-600">{errors.desc.message}</p>
          ) : null}
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Link Youtube
            <span className="text-xs text-gray-400 ml-1 font-normal">
              (VD: https://www.youtube.com/watch?v=AjWfY7SnMBI)
            </span>
          </label>
          <input
            type="text"
            {...register('youtube', {
              setValueAs(value) {
                return _.isString(value) && value.length > 0 ? value : null;
              },
            })}
            className={clsx(
              errors.youtube
                ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
              'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
            )}
          />
          {errors.youtube ? (
            <p className="text-xs text-red-600">{errors.youtube.message}</p>
          ) : null}
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Hình ảnh
            <span className="text-xs text-gray-400 ml-1 font-normal">
              (Tối đa 5 hình, mỗi hình không quá 5mb)
            </span>
          </label>
          <div className="block">
            <ImageList
              max={5}
              list={imageProps.list}
              action={imageProps.action}
            />
          </div>
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Trạng thái
          </label>
          <div className="flex justify-between">
            <div className="flex items-center justify-center space-x-1">
              <input
                id="status-active"
                type="radio"
                className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                value={CommentStatus.active}
                {...register('status')}
              />
              <label
                htmlFor="status-active"
                className="block text-sm font-normal text-gray-700"
              >
                Hiển thị
              </label>
            </div>
            <div className="flex items-center justify-center space-x-1">
              <input
                id="status-pending"
                type="radio"
                className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                value={CommentStatus.pending}
                {...register('status')}
              />
              <label
                htmlFor="status-pending"
                className="block text-sm font-normal text-gray-700"
              >
                Chờ duyệt
              </label>
            </div>
            <div className="flex items-center justify-center space-x-1">
              <input
                id="status-inactive"
                type="radio"
                className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                value={CommentStatus.inactive}
                {...register('status')}
              />
              <label
                htmlFor="status-inactive"
                className="block text-sm font-normal text-gray-700"
              >
                Tạm ẩn
              </label>
            </div>
          </div>
        </div>
      </div>
      <FormProductSearch show={productSearch.show} action={setProductSearch} />
    </>
  );
};
export default FormReview;
